import { render, staticRenderFns } from "./artist_index.html?vue&type=template&id=37ff27f9&scoped=true&external"
import script from "./artist_index.vue?vue&type=script&lang=js"
export * from "./artist_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff27f9",
  null
  
)

export default component.exports